var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"ts-text-xs"},[_vm._v("Note1: Click No date change to current date. "),_c('br'),_vm._v(" Note2: Click Yes product added will be clear.")])])
}]

export { render, staticRenderFns }